import { ParameterInfos } from 'ut-business/parameter';

export const dacParameters: Record<string, ParameterInfos> = {
  dacGain: {
    metric: {
      unit: 'dB',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'dB',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    sourceUnit: 'dB',
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  dacPointAmplitude: {
    metric: {
      unit: '%',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: '%',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  dacPointPosition: {
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    sourceUnit: 'm',
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  dacCompliance: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  dacCurveType: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  dacCurveConnect: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  dacTwentyEighty: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  dacWarningCurvesAmount: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  dacWarningCurves: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  evalCurve: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
};
